import { bootstrapApplication } from '@angular/platform-browser';
import { initializeSentry } from '@core/providers/sentry';
import { environment } from '@environments/environment';
import { logging } from '@utils/logging';
import { marked } from 'marked';
import { baseUrl } from 'marked-base-url';
import { App } from './app/app';
import { appConfig } from './app/app.config';

initializeSentry();

marked.use(baseUrl(environment.strapiUrl));

bootstrapApplication(App, appConfig).catch(err => logging.unknownError(err, { context: 'bootstrapApplication' }));
